import React from 'react';
import PropTypes from 'prop-types';

import './code-viewer.css';

const CodeViewer = ({ code }) => (
  <div className="code-viewer">
    <p className="code">
      {code.split('\n').map((l, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={`${i}-${l}`}>
          {l.replace(/ /g, '\u00a0')}
          <br />
        </React.Fragment>
      ))}
    </p>
  </div>
);

CodeViewer.propTypes = {
  code: PropTypes.string,
};

CodeViewer.defaultProps = {
  code: '',
};

export default CodeViewer;
